export const fieldStateMap = {
  init: 'init',
  intro: 'intro',
  camera: 'camera',
  result: 'result',
  check: 'check',
};
